import debounce from 'lodash/debounce';
import { useEffect, useMemo } from 'react';

export function useDebounceCallback<Args extends any[]>(callback: (...args: Args) => void, time: number) {
  const debounced = useMemo(() => debounce(callback, time), [callback, time]);

  useEffect(
    () => () => {
      debounced.cancel();
    },
    [debounced],
  );

  return debounced;
}
